import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';

import FeaturesCarousel from '~/components/blocks/acf/FeaturesCarousel';

import features1 from '~/images/exampleBlocks/features1.png';
import features2 from '~/images/exampleBlocks/features2.png';

const FeaturesCarouselBlock = ({
    attributes,
    globalBlockOptions: { globalBlockOptions },
    blockFeaturesCarousel: {
        title,
        slides = [],
        usePhoneScreen = false,
        mobileContent
    }
}) => (
    <FeaturesCarousel
        {...{
            attributes,
            globalBlockOptions,
            title,
            slides,
            usePhoneScreen,
            mobileContent
        }}
    />
);

FeaturesCarouselBlock.propTypes = {
    blockFeaturesCarousel: PropTypes.shape({
        title: PropTypes.string.isRequired,
        slides: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string.isRequired,
                description: PropTypes.string,
                image: PropTypes.shape({
                    id: PropTypes.string.isRequired,
                    altText: PropTypes.string,
                    sourceUrl: PropTypes.string.isRequired,
                    localFile: PropTypes.shape({
                        childImageSharp: PropTypes.shape({
                            gatsbyImageData: PropTypes.object.isRequired
                        })
                    })
                })
            })
        ),
        usePhoneScreen: PropTypes.bool,
        mobileContent: PropTypes.shape({
            title: PropTypes.string,
            features: PropTypes.arrayOf(
                PropTypes.shape({
                    icon: PropTypes.string.isRequired,
                    feature: PropTypes.string.isRequired
                })
            )
        })
    }).isRequired
};

export default FeaturesCarouselBlock;

export const fragment = graphql`
    fragment FeaturesCarouselBlockFragment on WpAcfFeaturesCarouselBlock {
        name
        attributes {
            anchor
            className
        }
        globalBlockOptions {
            globalBlockOptions {
                marginBottom
            }
        }
        blockFeaturesCarousel {
            title
            slides {
                title
                description
                image {
                    id
                    altText
                    sourceUrl
                    localFile {
                        childImageSharp {
                            gatsbyImageData(width: 630)
                        }
                    }
                }
            }
            usePhoneScreen
            mobileContent {
                title
                features {
                    icon
                    feature
                }
            }
        }
    }
`;

export const exampleData = [
    {
        variant: 'Default Features Carousel',
        description:
            'Title and Slides required. Phone Screen overlay is optional. Slides must contain a title and an image. Images intended to be a png if no phone screen used.',
        props: {
            name: 'acf/features-carousel',
            blockFeaturesCarousel: {
                title: 'Features Carousel Title',
                usePhoneScreen: false,
                slides: [
                    {
                        title: 'Lorem ipsum',
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                        image: {
                            id: '1',
                            sourceUrl: features1
                        }
                    },
                    {
                        title: 'Lorem ipsum dolor sit amet',
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                        image: {
                            id: '2',
                            sourceUrl: features2
                        }
                    }
                ]
            }
        }
    },
    {
        variant: 'Features Carousel with Phone Screen',
        description: 'Images should be .5 Aspect Ratio, Minimum 340px x 700px.',
        props: {
            name: 'acf/features-carousel',
            blockFeaturesCarousel: {
                title: 'Features Carousel Title',
                usePhoneScreen: true,
                slides: [
                    {
                        title: 'Lorem ipsum',
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                        image: {
                            id: '1',
                            sourceUrl: 'https://picsum.photos/340/700?random=1'
                        }
                    },
                    {
                        title: 'Lorem ipsum dolor sit amet',
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                        image: {
                            id: '2',
                            sourceUrl: 'https://picsum.photos/340/700?random=2'
                        }
                    },
                    {
                        title: 'Lorem ipsum dolor',
                        description:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
                        image: {
                            id: '3',
                            sourceUrl: 'https://picsum.photos/340/700?random=3'
                        }
                    }
                ],
                mobileContent: {
                    title: 'Features Carousel Title Mobile',
                    features: [
                        {
                            icon: 'plus',
                            feature: 'Feature 1'
                        },
                        {
                            icon: 'coin',
                            feature: 'Feature 2'
                        },
                        {
                            icon: 'shopping-bag',
                            feature: 'Feature 3'
                        }
                    ]
                }
            }
        }
    }
];
